<template>

    <trax-ui-card-with-background class="trax-top-box" :background-image="settings.background">
        <h3 class="card-title mt-3">{{ settings.title }}</h3>
        <p class="card-description" v-html="settings.text"></p>
        <a :href="settings.button_data" target="_blank" class="btn btn-round btn-default" 
            v-if="settings.button_enabled && settings.button_label && settings.button_data">

                <i class="material-icons">{{ settings.button_icon }}</i>
                {{ settings.button_label }}
        </a>
        <p class="mt-4 mb-0" v-if="settings.logo_enabled">
            <img :src="app_url+settings.logo_image">
        </p>
    </trax-ui-card-with-background>

</template>

<script>
    export default {
    
        data: function() {
            return {
                app_url: app_url,
                settings: data.home_settings,
            }
        }
    }
</script>
